(function ($) {
    $.fn.partnerCarousel = function () {
        return this.each(() => {
            let slider;
            const $self = $(this);
            const $slider = $self.find('.slides');
            const $slidesList = $slider.find('.splide__list');
            let slideCount = $slider.find('.splide__slide').length;

            let styleAttr = false;

            slider = new window.Splide($slider[0], {
                type: 'loop',
                perPage: (slideCount < 10 ? slideCount : 10),
                autoplay: true,
                interval: 0,
                speed: 1000 * slideCount,
                easing: 'linear',
                perMove: slideCount,
                arrows: false,
                pagination: false,
                breakpoints: {
                    990: {
                        perPage: (slideCount < 6 ? slideCount : 6), // or 'completely'
                    },
                    640: {
                        perPage: (slideCount < 3 ? slideCount : 3),
                    },
                },
            });

            // On slider mounted
            slider.on('mounted', function () {
                // If slide count is less than 10 calculate width 
                if (slideCount < 10) {
                    $slider.css('max-width', (slideCount * 140) + 'px');
                }
            });

            $slidesList.on('mouseenter', () => {
                styleAttr = $slidesList.attr('style');
                const offset = $slidesList.offset().left;
                $slidesList.addClass('paused');
                $slidesList.css('transform', 'translate(' + (offset - (Math.abs($self.offset().left))) + 'px, 0px)');
            });

            $slidesList.on('mouseleave', () => {
                const $lastSlide = $slidesList.find('.splide__slide.last:not(.splide__slide--clone)');

                const totalWidth = slideCount * $slidesList.find('.splide__slide').eq(0).outerWidth();
                const remainingSlidesWidth = $lastSlide.offset().left + $lastSlide.outerWidth() - $self.offset().left;

                const transitionSpeed = Math.abs(remainingSlidesWidth) * slider.options.speed / (totalWidth + $self.offset().left);

                $slidesList.removeClass('paused');
                $slidesList.attr('style', styleAttr);
                $slidesList.css('transition', 'transform ' + (transitionSpeed / 1000) + 's ' + slider.options.easing + ' 0s');
            });

            slider.mount();
        });
    }

    $(() => {
        $('.partner_logo_carousel').partnerCarousel();
    })

})($);


// WEBPACK FOOTER //
// ./scripts/modules/blocks/partner-carousel.js